/* eslint-disable no-param-reassign, no-nested-ternary */
// import Perf from 'react-addons-perf'; // eslint-disable-line import/no-extraneous-dependencies
import { createReducer } from 'Utils';
import TYPES from 'Catalog/types';

export const FILTER_TYPES = {
  CATEGORIES: 'categories',
  COURSES: 'courses',
  LEVELS: 'levels',
  SOFTWARES: 'softwares',
  LANGUAGES: 'languages',
};

const initialState = {
  allCourses: false,
  categorySelected: {
    itemId: null,
    subItemId: null,
  },
  categoryOpen: {
    itemId: null,
  },
  levelsSelected: {},
  softwaresSelected: {},
  languagesSelected: {},
  coursesSelected: {},
  categories: {},
  courses: {},
  levels: {},
  softwares: {},
  defaultSoftwares: {},
  defaultLevels: {},
  openDialog: false,
};

export default createReducer(initialState, {
  // ========================== Category ======================= //
  [TYPES.TOGGLE_FILTER_CATEGORY]: (state, { itemId, subItemId }) => {
    if (
      state.categorySelected.itemId === itemId &&
      state.categorySelected.subItemId === subItemId
    ) {
      const newState = {
        ...state,
        categorySelected: { itemId: null, subItemId: null },
        softwaresSelected: {},
        levelsSelected: {},
        softwares: {
          ...state.defaultSoftwares,
          open: false,
        },
        levels: {
          ...state.defaultLevels,
          open: false,
        },
      };

      if (typeof window !== 'undefined' && window.innerWidth <= 1024) {
        return {
          ...state,
          categorySelected: { itemId, subItemId },
          softwaresSelected: {},
          levelsSelected: {},
          softwares: {
            ...state.defaultSoftwares,
            open: false,
          },
          levels: {
            ...state.defaultLevels,
            open: false,
          },
        };
      }
      return newState;
    }

    return {
      ...state,
      allCourses: false,
      categorySelected: { itemId, subItemId },
      softwaresSelected: {},
      levelsSelected: {},
      softwares: {
        ...state.defaultSoftwares,
        open: false,
      },
      levels: {
        ...state.defaultLevels,
        open: false,
      },
    };
  },
  [TYPES.OPEN_FILTER_CATEGORY]: (state, { itemId }) => {
    const isClosing = itemId === state.categoryOpen.itemId;

    const newState = {
      ...state,
      allCourses: false,
      categoryOpen: {
        itemId: isClosing && window.innerWidth >= 1024 ? null : itemId,
      },
      softwares: {
        ...state.softwares,
        open: false,
      },
      levels: {
        ...state.levels,
        open: false,
      },
      softwaresSelected: {},
      levelsSelected: {},
    };

    if (window.innerWidth <= 1024) {
      newState.categorySelected = {
        itemId,
        subItemId: state.categorySelected.subItemId,
      };
      newState.softwares = {
        ...state.softwares,
      };
      newState.levels = {
        ...state.levels,
      };
    } else if (isClosing && window.innerWidth > 1024) {
      newState.categorySelected = {
        itemId: null,
        subItemId: null,
      };
      newState.softwares = {
        ...state.defaultSoftwares,
      };
      newState.levels = {
        ...state.defaultLevels,
      };
    } else {
      newState.categorySelected = {
        itemId,
        subItemId: 0,
      };
    }

    return newState;
  },
  // ========================== Category ======================= //

  [TYPES.OPEN_FILTER_COURSE]: state => ({
    ...state,
    courses: {
      ...state.categories,
      allCourses: false,
      open: false,
    },
  }),

  // ========================== Category ======================= //
  [TYPES.OPEN_FILTER_SOFTWARE]: state => ({
    ...state,
    softwares: {
      ...state.softwares,
      allCourses: false,
      open: !state.softwares.open,
    },
  }),

  [TYPES.TOGGLE_FILTER_SOFTWARE]: (state, { subItemId }) => {
    const softwareToSelect = state.softwares.subItems[subItemId];
    const newSoftwaresSelected = { ...state.softwaresSelected };
    const softwareExists = Boolean(newSoftwaresSelected[subItemId]);

    if (softwareExists) {
      delete newSoftwaresSelected[subItemId];
      return {
        ...state,
        softwaresSelected: {
          ...newSoftwaresSelected,
        },
      };
    }

    return {
      ...state,
      allCourses: false,
      softwaresSelected: {
        ...state.softwaresSelected,
        [subItemId]: {
          ...softwareToSelect,
        },
      },
    };
  },

  // ========================== Category ======================= //
  [TYPES.OPEN_FILTER_LEVEL]: state => ({
    ...state,
    levels: {
      ...state.levels,
      allCourses: false,
      open: !state.levels.open,
    },
  }),
  [TYPES.TOGGLE_FILTER_LEVEL]: (state, { subItemId }) => {
    const levelToSelect = state.levels.subItems[subItemId];
    const newLevelsSelected = { ...state.levelsSelected };
    const levelExists = Boolean(newLevelsSelected[subItemId]);

    if (levelExists) {
      delete newLevelsSelected[subItemId];
      return {
        ...state,
        levelsSelected: {
          ...newLevelsSelected,
        },
      };
    }

    return {
      ...state,
      allCourses: false,
      levelsSelected: {
        ...state.levelsSelected,
        [subItemId]: {
          ...levelToSelect,
        },
      },
    };
  },

  /** *********Languages********* */
  [TYPES.OPEN_FILTER_LANGUAGE]: state => ({
    ...state,
    languages: {
      ...state.languages,
      open: !state.languages.open,
    },
  }),

  [TYPES.TOGGLE_FILTER_LANGUAGE]: (state, { subItemId }) => {
    const optionToSelect = state.languages.subItems[subItemId];
    const newSelectedOptions = { ...state.selectedLanguages };
    const optionExist = Boolean(newSelectedOptions[subItemId]);

    if (optionExist) {
      delete newSelectedOptions[subItemId];
      return {
        ...state,
        selectedLanguages: {
          ...newSelectedOptions,
        },
      };
    }

    return {
      ...state,
      selectedLanguages: {
        ...state.selectedLanguages,
        [subItemId]: {
          ...optionToSelect,
        },
      },
    };
  },

  [TYPES.SET_SELECTED_LANGUAGES]: (state, payload) => {
    return {
      ...state,
      selectedLanguages: { ...payload },
    };
  },

  // ============================ COMMON ================== //
  [TYPES.SHOW_ALL_COURSES]: state => ({
    ...state,
    allCourses: true,
    showRecommendedForMeCourses: false,
  }),

  [TYPES.CLEAR_ALL_FILTERS]: state => ({
    ...state,
    categorySelected: {
      itemId: null,
      subItemId: null,
    },
    categoryOpen: {
      itemId: null,
    },
    levelsSelected: {},
    softwaresSelected: {},
    selectedLanguages: {},
    levels: {
      ...state.defaultLevels,
      open: false,
    },
    softwares: {
      ...state.defaultSoftwares,
      open: false,
    },
    languages: {
      ...state.defaultLanguages,
      open: false,
    },
    showRecommendedForMeCourses: false,
  }),

  [TYPES.CLEAR_SOFTWARE_FILTERS]: state => ({
    ...state,
    softwaresSelected: {},
  }),

  [TYPES.CLEAR_LEVELS_FILTERS]: state => ({
    ...state,
    levelsSelected: {},
  }),

  [TYPES.TOGGLE_FILTER_DIALOG]: state => ({
    ...state,
    openDialog: !state.openDialog,
  }),

  // disable the filter that has no results(courses)
  [TYPES.DISABLE_FILTERS_SOFTWARE_LEVELS]: (state, { softwares, levels }) => {
    const newState = {};

    // check if the software is available
    if (softwares && softwares.length > 0) {
      const { subItems } = state.softwares;
      const newSoftwares = Object.keys(subItems).reduce((obj, key, index) => {
        const currentSoftware = subItems[key];
        const isIncluded = softwares.includes(currentSoftware.slug);

        obj[
          isIncluded ? currentSoftware.id : `${index}-${currentSoftware.id}`
        ] = {
          ...currentSoftware,
          disabled: !isIncluded,
        };

        return obj;
      }, {});

      newState.softwares = {
        ...state.softwares,
        subItems: newSoftwares,
      };
    } else {
      newState.softwares = {
        ...state.defaultSoftwares,
        open: state.softwares.open,
        subItems: {
          ...state.defaultSoftwares.subItems,
        },
      };
    }

    if (levels && levels.length > 0) {
      const { subItems } = state.levels;
      const newLevels = Object.keys(subItems).reduce((obj, key) => {
        const currentLevel = subItems[key];

        obj[key] = {
          ...currentLevel,
          disabled: !levels.includes(currentLevel.slug),
        };

        return obj;
      }, {});

      newState.levels = {
        ...state.levels,
        subItems: newLevels,
      };
    } else {
      newState.levels = {
        ...state.defaultLevels,
        open: state.levels.open,
        subItems: {
          ...state.defaultLevels.subItems,
        },
      };
    }

    return {
      ...state,
      ...newState,
    };
  },
});
